// extracted by mini-css-extract-plugin
export default {"gototop":"gototop_gototop__TVNlo","gototopActive":"gototop_gototopActive__uYAuU"};